export default __webpack_public_path__ + "static/media/selecta_main_mobile_small@2x.ea04bda1.jpg";